import styles from "./Loading.module.css";

const Loading = () => {
  return (
    <div className={styles.wrap} role="status" aria-label="Loading">
      <div className={styles.dots}>
        <span className={styles.dot} />
        <span className={styles.dot} />
        <span className={styles.dot} />
      </div>
    </div>
  );
};

export default Loading;
